export default class DialogManager extends HTMLElement {
  constructor() {
    super();

    this.abortController = new AbortController();
  }

  get toggle() {
    return this.querySelector("[data-dialog-open]");
  }

  get dialog() {
    return this.querySelector("dialog");
  }

  get closeButton() {
    return this.dialog?.querySelector("[data-dialog-close]");
  }

  connectedCallback() {
    if (!this.dialog) return;

    this.toggle?.addEventListener("click", this.handleClick, {
      signal: this.abortController.signal,
    });
    this.addEventListener("dialog:close", () => this.dialog.close(), {
      signal: this.abortController.signal,
    });
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  handleClick = () => {
    this.dialog?.showModal();
  };
}
